import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const NetworkStatusContext = createContext({
  isOnline: true,
  wasOffline: false,
  dismissRestored: () => {}
});

export function useNetworkStatus() {
  return useContext(NetworkStatusContext);
}

export default function NetworkStatusProvider({ children }) {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setWasOffline(true);

      setTimeout(() => setWasOffline(false), 4000);
    };
    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  const dismissRestored = useCallback(() => setWasOffline(false), []);

  return (
    <NetworkStatusContext.Provider value={{ isOnline, wasOffline, dismissRestored }}>
      {children}
    </NetworkStatusContext.Provider>);

}
